import { render, staticRenderFns } from "./mobileContent3.vue?vue&type=template&id=132e506d&scoped=true"
import script from "./mobileContent3.vue?vue&type=script&lang=js"
export * from "./mobileContent3.vue?vue&type=script&lang=js"
import style0 from "./mobileContent3.vue?vue&type=style&index=0&id=132e506d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e506d",
  null
  
)

export default component.exports